import { render, staticRenderFns } from "./indirect.vue?vue&type=template&id=28d972f2&"
import script from "./indirect.vue?vue&type=script&lang=js&"
export * from "./indirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports